export type AppMessage = string | Record<string, unknown>;

export function postToApp(payload: AppMessage): void {
  try {
    if (window.parent && window.parent !== window) {
      window.parent.postMessage(
        typeof payload === 'string' ? payload : JSON.stringify(payload),
        '*'
      );
    }
  } catch {
    /* noop */
  }
}
